module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921012651_T.2b05618e.jpg";